module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "slot-machine",
    class: {
      'is-running': _vm.isRunning
    }
  }, [_c('div', {
    staticClass: "slot-machine__wrap"
  }, _vm._l((_vm.slots), function(slot) {
    return _c('div', {
      ref: "slots",
      refInFor: true,
      staticClass: "slot"
    }, [_c('h2', {
      staticClass: "slot__title"
    }, [_vm._v(_vm._s(slot.title))]), _c('div', {
      staticClass: "slot__window"
    }, [_c('div', {
      staticClass: "slot__wrap"
    }, [_vm._l((slot.items), function(opt) {
      return _c('div', {
        staticClass: "slot__item"
      }, [_c('span', [_vm._v(_vm._s(opt))])])
    }), _c('div', {
      staticClass: "slot__item slot__item--copy"
    }, [_c('span', [_vm._v(_vm._s(slot.items[0]))])])], 2)])])
  })), _c('primary-button', {
    staticClass: "slot-machine__lever",
    attrs: {
      "loading": _vm.opts
    },
    on: {
      "clicked": function($event) {
        $event.preventDefault();
        _vm.start($event)
      }
    }
  }, [_vm._v("Draaien!")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d51915b8","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/partials/SlotMachinePartial.vue
// module id = Mq8A
// module chunks = 1